import Vue from 'vue'

export default {
    initLocalStorage() {
        this.noLocalStorage = !window.localStorage

        this.localStorage = this.noLocalStorage ? {} : Vue.localStorage

        if (this.noLocalStorage) {
            this.localStorage['settings'] = {}
        } else {
            this.localStorage.addProperty('settings', Object, {})
        }
    },

    get(key, _default) {
        if (this.noLocalStorage) {
            return this.localStorage[key]
        } else {
            return this.localStorage.get(key, _default)
        }
    },

    set(key, value) {
        if (this.noLocalStorage) {
            this.localStorage[key] = value
        } else {
            this.localStorage.set(key, value)
        }
    },

    remove(key) {
        if (this.noLocalStorage) {
            delete this.localStorage[key]
        } else {
            this.localStorage.remove(key)
        }
    },

    tryParse(str) {
        try {
            return JSON.parse(str)
        } catch (e) {
            return str
        }
    },

    resetCache() {
        window.localStorage.clear()

        this.initLocalStorage()
    }
}
